import { Palette } from '@mui/material/styles/createPalette';

export function deletePropertiesStartingWith(propName: string, obj: unknown) {
    if (obj) {
        for (const prop in obj) {
            if (prop.startsWith(propName)) {
                delete obj[prop];
            }
        }
    }
}

export function deletePropertiesEndingWith(propName: string, obj: unknown) {
    if (obj) {
        for (const prop in obj) {
            if (prop.endsWith(propName)) {
                delete obj[prop];
            }
        }
    }
}

export const getKeyValue =
    <U extends keyof T, T extends Record<string, string> | Palette>(key: U) =>
    (obj: T) =>
        obj[key];
